/**
 * The door types an opening can be set to, in dropdown order, with their
 * display labels. The values are the detection door types the
 * frame-and-opening step recognises; any other detected type is left unset.
 */
export const OpeningDoorType = [
	{ value: 'hinged_door', label: 'Hinged door' },
	{ value: 'cavity_door', label: 'Cavity door' },
	{ value: 'bifold_door', label: 'Bifold door' },
	{ value: 'barn_door', label: 'Barn door' },
	{ value: 'garage_door', label: 'Garage door' },
	{ value: 'double_hinged_door', label: 'Double hinged door' },
	{ value: 'internal_sliding_door', label: 'Internal sliding door' },
	{ value: 'external_sliding_door', label: 'External sliding door' },
] as const;
